import { render, staticRenderFns } from "./UserDisabled.vue?vue&type=template&id=c8d20a5a&"
import script from "./UserDisabled.vue?vue&type=script&lang=js&"
export * from "./UserDisabled.vue?vue&type=script&lang=js&"
import style0 from "./UserDisabled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports